"use client";

import { motion } from "motion/react";

/**
 * Shared scroll-reveal primitives — same fade/rise/unblur spec the
 * /about page uses for its stat grid, achievements, beyond cards.
 *
 * `RevealGroup` sets up the stagger container. `RevealItem` is each
 * card that cascades in. Both accept `as` so you can keep semantic
 * tags (ul, section, article, li, etc.).
 */
const PORTRAIT_EASE = [0.22, 1, 0.36, 1];

const ITEM_VARIANTS = {
  hidden: { opacity: 0, y: 32, filter: "blur(8px)" },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.85, ease: PORTRAIT_EASE },
  },
};

const VIEWPORT_ONCE = { once: true, amount: 0.2 };

export function RevealGroup({
  as = "div",
  className,
  children,
  stagger = 0.1,
  amount,
  ...rest
}) {
  const Tag = motion[as] || motion.div;
  const viewport = amount !== undefined ? { once: true, amount } : VIEWPORT_ONCE;
  return (
    <Tag
      className={className}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger } },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function RevealItem({ as = "div", className, children, ...rest }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag className={className} variants={ITEM_VARIANTS} {...rest}>
      {children}
    </Tag>
  );
}
